import { IngestionSourceParametersType } from '../../gamma-api';
import { IbIconName } from '../components/common/IbIcon';

export const getSourceTypeIconName = (type?: IngestionSourceParametersType | null): IbIconName => {
  if (
    type === IngestionSourceParametersType.WebsiteUrls ||
    type === IngestionSourceParametersType.WebsiteCrawler ||
    type === IngestionSourceParametersType.Website
  ) {
    return 'international';
  }

  if (type === IngestionSourceParametersType.File) {
    return 'paperclip';
  }

  if (type === IngestionSourceParametersType.Elma365) {
    return 'elma365';
  }

  if (type === IngestionSourceParametersType.Confluence) {
    return 'confluence';
  }

  return 'paperclip';
};
